import Dialog from "@components/Dialog"
import { useKeymap } from "@features/keymap/useKeymap"
import { atom, useAtom } from "jotai"

export const openShortcutsInfoDialogAtom = atom(false)
if (process.env.NODE_ENV !== "production") {
  openShortcutsInfoDialogAtom.debugLabel = "openShortcutsInfoDialogAtom"
}

export const ActiveShortcutsInfoDialog = () => {
  const keymap = useKeymap()
  const [open, setOpen] = useAtom(openShortcutsInfoDialogAtom)

  return (
    <Dialog
      open={open}
      title="Active shortcuts"
      onClose={() => setOpen(false)}
      closeOnBackdropClick
    >
      <table>
        <thead></thead>
        <tbody>
          {keymap
            .getKeymaps()
            .list.sort()
            .reverse()
            .map((k) => (
              <tr key={k.shortcut}>
                <td>{k.desc}</td>
              </tr>
            ))}
        </tbody>
      </table>
    </Dialog>
  )
}
